<template>
  <v-content>
    <v-layout row justify-center>
      <v-dialog v-model="docLoading" transition="false" persistent fullscreen content-class="loading-dialog">
        <v-container fill-height>
          <v-layout row justify-center align-center>
            <v-progress-circular indeterminate :size="70" :width="7" color="red"></v-progress-circular>
          </v-layout>
        </v-container>
      </v-dialog>
    </v-layout>
    <span v-if="!loading && (docId_ === null || notFound === false)">
      <form action="submit">
        <slot name="title" v-bind:title="formModel.name">
          <h2>{{ formModel.name }}</h2>
        </slot>
        <!-- <pre>DATA: {{ JSON.stringify($data.formData, null, 2)}}</pre>
        <pre>{{ JSON.stringify(formModel, null, 2)}}</pre>
        <pre>isloaded /exists : {{  docIsLoaded }} / {{ docExists}}</pre>
        <pre>notfound : {{  notFound  }}</pre>
        <pre>docId_: {{ docId_}}</pre>
        <pre>$v: {{ JSON.stringify($v, null, 2)}}</pre>
        <pre>loading <b>{{ docLoading }}</b></pre> -->
        <span v-for="(prop,index) in sortedProps" :key="`${index}-${prop.name}`">
          <v-text-field :ref="prop.name" v-model="formData[prop.name]" v-if="prop.type==='text'" :label="prop.label" :error-messages="errors(prop)" @input="$v.formData[prop.name].$touch()" @blur="$v.formData[prop.name].$touch()"></v-text-field>
          <v-text-field :ref="prop.name" v-model="formData[prop.name]" v-if="prop.type==='integer'" :label="prop.label" :error-messages="errors(prop)" @input="$v.formData[prop.name].$touch()" @blur="$v.formData[prop.name].$touch()"></v-text-field>
          <v-select :ref="prop.name" v-model="formData[prop.name]" v-if="prop.type==='select'" :label="prop.label" :items="prop.options" item-text="text" item-value="id" :error-messages="errors(prop)" @change="$v.formData[prop.name].$touch()" @blur="$v.formData[prop.name].$touch()"></v-select>
        </span>
        <slot name="actions" v-bind:disabled="$v.formData.$invalid" v-bind:submitHandler="submit">
          <v-btn :disabled="$v.formData.$invalid" @click="submit">Guardar</v-btn>
        </slot>
      </form>
    </span>
  </v-content>
</template>

<script>
import { mapState } from "vuex";
import firebase from "firebase/app";
import "firebase/firestore";
import { validationMixin } from "vuelidate";
import {
  required,
  requiredIf,
  requiredUnless,
  minLength,
  maxLength,
  minValue,
  maxValue,
  between,
  alpha,
  alphaNum,
  numeric,
  integer,
  decimal,
  email,
  sameAs,
  url
} from "vuelidate/lib/validators";

const db = firebase.firestore();
const validators = {
  required,
  requiredIf,
  requiredUnless,
  minLength,
  maxLength,
  minValue,
  maxValue,
  between,
  alpha,
  alphaNum,
  numeric,
  integer,
  decimal,
  email,
  sameAs,
  url
};
const errMessage = function(prop, vType, $v, $refs) {
  //prop es el objeto elemento del array props como se creo en firestore
  //vType (string) el typo de validator: required, maxLength ...
  let params = $v.formData[prop.name].$params[vType];
  const getLabel = name => {
    return name && $refs[name][0].label;
  };
  const msg = {
    // validator_name: (prop, paramsm $refs) => `error text`
    required: `se requiere ${prop.label}`,
    requiredIf: `se requiere ${prop.label}`,
    requiredUnless: `se requiere ${prop.label}`,
    minLength: `${prop.label} debe tener al menos ${params.min} caracteres`,
    maxLength: `${prop.label} debe tener maximo ${params.max} caracteres`,
    minValue: `el valor minimo de ${prop.label} es de ${params.min}`,
    maxValue: `el valor maximo de ${prop.label} es de ${params.max}`,
    between: `${prop.label} debe estar entre ${params.min} y ${params.max}`,
    alpha: `solo letras`,
    alphaNum: `solo caracteres alfanumericos`,
    numeric: `solo numeros`,
    integer: `debe ser un numero entero`,
    decimal: `debe ser un numero decimal`,
    email: `debe ser un  email valido`,
    sameAs: `debe ser igual a ${getLabel(params.eq)}`,
    url: `debe ser un url valido`
  };
  return msg[vType];
};

export default {
  props: {
    formId: {
      type: String,
      required: true
    },
    docId: {
      type: String
    }
  },
  mixins: [validationMixin],
  validations() {
    let validations = {};
    validations.formData = {};
    this.formModel.props.forEach(p => {
      let prop_validations = {};
      p.validations.forEach(o => {
        Object.keys(o).map(k => {
          prop_validations[k] = o[k]
            ? validators[k].apply(null, o[k])
            : validators[k];
        });
      });
      validations.formData[p.name] = prop_validations;
    });
    return validations;
  },
  data() {
    return {
      formData: {},
      docId_: this.docId || null
    };
  },
  methods: {
    submit() {
      this.$v.formData.$touch();
      if (!this.$v.formData.$invalid) {
        if (this.docExists) {
          //update
          this.docRef.set(this.formData, { merge: true });
        } else {
          //create
          let docRef = this.collectionRef.doc();
          docRef.set(this.formData).then(() => {
            this.$router.push(
              `${this.$route.path.replace(/\/$/, "")}/${docRef.id}`
            );
          });
        }
      }
    },
    setFormKeys() {
      this.formModel.props.map(p => {
        this.$set(
          this.formData,
          p.name,
          this.document ? this.document[p.name] : null
        );
      });
    },
    errors(prop) {
      const error = [];
      if (!this.$v.formData[prop.name].$dirty) return error;
      prop.validations.forEach(o => {
        Object.keys(o).map(k => {
          !this.$v.formData[prop.name][k] &&
            error.push(errMessage(prop, k, this.$v, this.$refs));
        });
      });
      return error;
    }
  },
  computed: {
    ...mapState([
      "entities",
      "documents",
      "docsLoaded",
      "docLoading",
      "loading"
    ]),
    formModel() {
      if (this.formId) {
        return this.entities
          ? this.entities.find(e => e.id === this.formId)
          : null;
      }
      return {};
    },
    docRef() {
      return (
        this.formModel &&
        this.docId_ &&
        db.collection(this.formModel.collection).doc(this.docId_)
      );
      // return (
      //   this.formModel &&
      //   this.docId &&
      //   this.document && //document exists
      //   db.collection(this.formModel.collection).doc(this.docId_)
      // );
    },
    docKey() {
      if (this.docRef) {
        return `${this.docRef.parent.id}/${this.docRef.id}`;
      }
      return null;
    },
    document() {
      return this.docKey && this.documents[this.docKey];
    },
    collectionRef() {
      return this.formModel && db.collection(this.formModel.collection);
    },
    sortedProps() {
      if (this.formModel) {
        let props = this.formModel.props.slice();
        props.sort((a, b) => {
          if (a.order < b.order) return -1;
          if (a.order > b.order) return 1;
          return 0;
        });
        return props;
      }
      return [];
    },
    docIsLoaded() {
      return (
        this.docKey &&
        this.docsLoaded &&
        (typeof this.docsLoaded[this.docKey] === "boolean"
          ? this.docsLoaded[this.docKey]
          : null)
      );
    },
    docExists() {
      return this.docIsLoaded && this.document !== null;
    },
    notFound() {
      return this.docId_ !== null && this.docIsLoaded && !this.docExists;
    }
  },
  watch: {
    docRef(value) {
      value && this.$store.dispatch("addDocument", this.docRef);
    },
    formModel(value) {
      value && this.setFormKeys();
    },
    document() {
      this.setFormKeys();
    },
    docId(value) {
      this.docId_ = value;
    },
    notFound(value) {
      if (value) {
        this.$router.push("/notfound");
      }
    }
  }
};
</script>
<style scoped>
.loading-dialog {
  background-color: #303030;
}
</style>
